/**
 * Validation
 */
class Validation {
  constructor(elements) {
    this.elements = elements;
  }

  events() {
    const that = this;

    $.each(this.elements, function(index) {
      let element = that.elements[index];

      $(document).on("blur", "." + element.inputClass, function() {
        that.validate($(this), element.regExp, element.value);
      });
    });
  }

  validate(input, regExp, value) {
    let isMatch = regExp.test(input.val());

    if (!isMatch) {
      input.val(value);
    }
  }

  init() {
    this.events();
  }
}

export default Validation;
